import request from "../utils/request";

export function getAreaOption(level: number, parent?: number) {
    return request.get('/com/area', {params: {level, parent}});
}

export function getAreaCascade(level?: number, levelLast?: number) {
    return request.get('/com/cascadeArea', {params: {level, levelLast}});
}
